import React, { createContext, useContext, useMemo } from 'react';
import { detectLanguage, getTranslations } from '../utils/i18n';

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const value = useMemo(() => {
    const lang = detectLanguage();
    return { t: getTranslations(lang), lang };
  }, []);

  return React.createElement(I18nContext.Provider, { value }, children);
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
